import { type ComponentProps } from "react";

import { DROPDOWN_PANEL_SCROLL_BODY_CLASS } from "@/components/molecules/dropdownPanel/dropdownPanel";
import { cn } from "@/lib/utils";

export const DropdownPanelScrollBody = ({
  className,
  onWheel,
  ...props
}: ComponentProps<"div">) => (
  <div
    data-dropdown-panel-scroll
    className={cn(DROPDOWN_PANEL_SCROLL_BODY_CLASS, className)}
    onWheel={(e) => {
      e.stopPropagation();
      onWheel?.(e);
    }}
    {...props}
  />
);
